import {MainRequest} from '../../Services/common';
import dayjs from 'dayjs';
import _ from 'lodash-es';

export const enum ClassType {
    System = '0', //0:系统内置,
    Other = '1', // 1:外部接口
}

export const enum Status {
    Close = '0', // 0:停用
    Open = '1', // 1:启用
}

//----------------------------------业务方法-------------------------------

export interface FunctionListItem {
    id: string;
    className: string; //分类名称
    createTime: string; //创建时间
    description: string; //说明
    code: string; //编码
    name: string;
    params: string; //参数str
    paramsJson: ParamsInfo[]; //参数json
}

interface FunctionList {
    dataList: FunctionListItem[];
    allRowNum: number;
}

export interface FunctionParams {
    currPage: number;
    pageSize: number; //每页条数
    name?: string; //按照名称模糊查询, code精确查询
    classType?: ClassType;
}

/**
 * 业务方法列表
 */
export function getFunctionPage(params: FunctionParams) {
    const newParams = {
        ...params,
        name: params?.name?.trim(),
    };

    return MainRequest.post<SuccessDataPagination<FunctionList>>(
        `/function/functionPage`,
        newParams,
    )
        .then(res => res.data.data)
        .then(res => {
            return {
                total: res.allRowNum,
                data: res.dataList,
            };
        });
}

export interface ParamsInfo {
    desc: string;
    name: string;
    required: string;
    type: string;
    value: string;
}

export interface ServiceListItem {
    id: string;
    name: string; //名称
    code: string; //编码
    className: string; //分类名称
    classType: string; //分类代码
    description: string; //说明
    functionDefineUuid: string; //数据同步方法uuid
    params: string; //参数str
    paramsJson: ParamsInfo[]; //参数json
}

/**
 * 服务列表
 * @param name 按照名称模糊查询, code精确查询
 * @param classType   分类, 0:系统内置, 1:外部接口
 */

export function getFunctionList(name?: string, classType?: ClassType) {
    return MainRequest.post<SuccessData<ServiceListItem[]>>(
        `/function/functionList`,
        {name, classType},
    ).then(res => res.data.data);
}

//获取paramsJson
export function getParamsJson(serviceList: ServiceListItem[], id: string) {
    return serviceList.find((item: ServiceListItem) => item.id === id)
        ?.paramsJson;
}

//----------------------------------调度任务-------------------------------

export interface User {
    id: string;
    loginName: string;
    name: string;
}

export interface TaskListItem {
    id: string;
    className: string; //分类名称
    description: string; //说明
    code: string; //编码
    name: string; //名称
    startDate: string; //有效开始日
    endDate: string; //有效结束日
    status: Status; //1启用 0停用
    createUser: User; //创建人
    updateUser: User; //更新人
    createTime: string; //创建时间
    updateTime: string; //更新时间
    serviceList: any[];
}

export interface TaskParams {
    currPage: number;
    pageSize: number; //每页条数
    name?: string; //按照名称模糊查询, code精确查询
    status?: Status; //1启用 0停用
}

/**
 * 调度任务列表
 */
export function getTaskPage(params: TaskParams) {
    const newParams = {
        ...params,
        name: params?.name?.trim(),
    };

    return MainRequest.post<SuccessDataPagination<TaskListItem[]>>(
        `/task/taskPage`,
        newParams,
    )
        .then(res => res.data.data)
        .then(data => {
            const dataList = data.dataList.map(item => ({
                ...item,
                serviceList: item.serviceList.map(list => ({
                    serviceId: list.id,
                    params: list.params,
                })),
            }));

            return {allRowNum: data, dataList: dataList};
        })
        .then(res => {
            return {
                total: res.allRowNum,
                data: res.dataList,
            };
        });
}

/**
 * 调度任务启用，停用
 * @param id
 * @param status    1: 启用,  0:停用
 */

export function changeTaskStatus(id: string, status: string) {
    return MainRequest.post(`/task/taskChangeStatus`, {id, status});
}

/**
 * 调度任务删除
 * @param id
 */

export function deleteTask(id: string) {
    return MainRequest.post(`/task/taskDelete`, {id});
}

interface Service {
    id: string;
    params: {[key: string]: string};
}
export interface TaskSaveParams {
    id?: string; //数据id, 新增时不传此参数
    name: string; //调度任务名称
    code: string; //编码
    service: Service[]; //业务方法列表json数组字符串
    description?: string; //描述
    status: Status;
}

export function saveTask(params: TaskSaveParams) {
    const service = params.service.map((item: any) => {
        const newItem = _.omit(item, 'params');
        return {id: item.serviceId, params: _.omit(newItem, 'serviceId')};
    });

    const newParams = {
        ...params,
        name: params.name
            ? params.name.trim()
            : dayjs().format('MM-DD HH:mm') + ' 新增的调度任务',
        service: JSON.stringify(service),
    };

    return MainRequest.post(`/task/taskSave`, newParams);
}

//将对象数组中的所有对象合并为一个对象
export function mergeObj<T>(list: T[]) {
    return list.reduce((acc, value) => ({...acc, ...value}));
}

/**
 * 调度任务执行操作
 * @param id
 */
export function executeTask(id: string) {
    return MainRequest.post(`/task/taskExecute`, {id});
}

export const enum ResultType {
    All = '',
    Success = '0',
    Doing = '1',
    Error = '2',
}

export const ResultTypeMap = {
    [ResultType.All]: '',
    [ResultType.Success]: '执行成功',
    [ResultType.Doing]: '执行中',
    [ResultType.Error]: '执行失败',
};

export interface TaskResultListItem {
    id: string;
    name: string; //名称
    code: string; //编码
    eid: string; //任务执行唯一id
    num: string; //处理数据量
    status: ResultType; //执行结果 0执行成功, 1执行中, 2执行失败
    createTime: string; //开始执行时间
    costTime: string; //执行成功时总耗时
}

export interface TaskResultParams {
    currPage: number;
    pageSize: number; //每页条数
    name?: string; //按照名称模糊查询, code精确查询
    status?: ResultType; //执行 0执行成功, 1执行中, 2执行失败
}

/**
 * 调度日志分页列表
 */
export function getTaskResultPage(params: TaskResultParams) {
    const newParams = {...params, name: params.name?.trim()};
    return MainRequest.post<SuccessDataPagination<TaskResultListItem[]>>(
        `/task/taskResultPage`,
        newParams,
    )
        .then(res => res.data.data)
        .then(res => {
            return {
                total: res.allRowNum,
                data: res.dataList,
            };
        });
}

export interface TaskLogListItem {
    data: string;
    type: string;
    time: string;
    table: string;
    desc: string;
}

interface TaskLogParams {
    currPage: number;
    pageSize: number;
    eid: string;
    search?: string;
}

/**
 * 调度计划详情列表
 */
export function pageTaskLog(params: TaskLogParams) {
    const newParams = {...params, search: params.search?.trim()};
    return MainRequest.post<SuccessDataPagination<TaskLogListItem[]>>(
        `/task/pageTaskLog`,
        newParams,
    )
        .then(res => res.data.data)
        .then(data => {
            const newList = data.dataList.map((item, index) => ({
                ...item,
                key: index + 1,
            }));
            return {allRowNum: data.allRowNum, dataList: newList};
        });
}

//----------------------------------调度计划-------------------------------

export interface PlanListItem extends TaskListItem {
    cron: string; //时间表达式
    taskList: TaskListItem[];
    task: string;
}

export interface PlanList {
    dataList: PlanListItem[];
    allRowNum: number;
}

export interface PlanParams {
    currPage: number;
    pageSize: number; //每页条数
    name?: string; //按照名称模糊查询, code精确查询
    status?: Status; //1启用 0停用
}

/**
 * 调度计划列表
 */
export function getPlanPage(params: PlanParams) {
    const newParams = {
        ...params,
        name: params?.name?.trim(),
    };

    return MainRequest.post<SuccessDataPagination<PlanList>>(
        `/plan/planPage`,
        newParams,
    )
        .then(res => res.data.data)
        .then(res => {
            return {
                total: res.allRowNum,
                data: res.dataList,
            };
        });
}

/**
 * 调度计划启用停用
 * @param id
 * @param status  1: 启用,  0:停用
 */

export function changePlanStatus(id: string, status: string) {
    return MainRequest.post(`/plan/planChangeStatus`, {id, status});
}

/**
 * 调度计划删除
 * @param id
 */

export function deletePlan(id: string) {
    return MainRequest.post(`/plan/planDelete`, {id});
}

export interface PlanSaveParams {
    id?: string; //数据id, 新增时不传此参数
    name: string; //默认调度计划
    code?: string; //编码
    cron?: string; //执行周期 cron字符串
    startDate?: string; //有效开始日
    endDate?: string; //有效结束日
    task: {taskList: string; id: string}[]; //调度任务ids 1,2,3,4
    description: string; //描述
    status: Status;
}

/**
 * 调度计划保存
 * @param params
 */
export function savePlan(params: PlanSaveParams) {
    const newParams = {
        ...params,
        name: params.name
            ? params.name.trim()
            : dayjs().format('MM-DD HH:mm') + ' 新增的调度计划',
        startDate: params.startDate
            ? dayjs(params.startDate).format('YYYY-MM-DD')
            : '',
        endDate: params.endDate
            ? dayjs(params.endDate).format('YYYY-MM-DD')
            : '',
        task: params.task.map(item => item.id).join(),
    };

    return MainRequest.post(`/plan/planSave`, newParams);
}

/**
 * 列表
 * @param name
 * @param status
 */
export function getTaskList(name?: string, status?: Status) {
    return MainRequest.post<SuccessData<TaskListItem[]>>(`/task/taskList`, {
        name,
        status,
    }).then(res => res.data.data);
}
